function updatePlaceholder() {
    const input = document.getElementById('zip-field');
    if (input) {
        input.placeholder = window.innerWidth < 420 ? 'Zip/Postal Code' : 'Enter Zip/Postal Code';
    }
}

window.addEventListener('load', updatePlaceholder);
window.addEventListener('resize', updatePlaceholder);

// breadcrumb navigation
document.addEventListener('DOMContentLoaded', function() {
  const prevBtn = document.getElementById('breadcrumb_previous');
  const nextBtn = document.getElementById('breadcrumb_next');
  const crumbs = document.querySelectorAll('.crumb');
  
  if (!prevBtn || !nextBtn || !crumbs.length) return;
  
  function updateButtons() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    prevBtn.style.display = activeIndex === 0 ? 'none' : '';
    nextBtn.style.display = activeIndex === crumbs.length - 1 ? 'none' : '';
  }
  
  prevBtn.addEventListener('click', function() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    if (activeIndex > 0) {
      activeCrumb.classList.remove('active');
      crumbs[activeIndex - 1].classList.add('active');
      updateButtons();
    }
  });
  
  nextBtn.addEventListener('click', function() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    if (activeIndex < crumbs.length - 1) {
      activeCrumb.classList.remove('active');
      crumbs[activeIndex + 1].classList.add('active');
      updateButtons();
    }
  });
  
  updateButtons();
});

var ESTIMATE_QUANTITY_FIELD_IDS = ['field_2_7', 'field_2_9', 'field_2_10', 'field_2_17'];

function reorderEstimateStepper(wrapper, input) {
  const up = wrapper.querySelector(':scope > .increment');
  const down = wrapper.querySelector(':scope > .decrement');
  if (!input || !up || !down) {
    return;
  }
  wrapper.appendChild(down);
  wrapper.appendChild(input);
  wrapper.appendChild(up);
}

function getEstimateQuantityMin(input) {
  var min = parseFloat(input.getAttribute('min'), 10);
  return isNaN(min) ? 0 : min;
}

function clampEstimateQuantityValue(input) {
  var min = getEstimateQuantityMin(input);
  var max = parseFloat(input.getAttribute('max'), 10);
  var value = parseFloat(input.value, 10);

  if (isNaN(value)) {
    return;
  }

  if (value < min) {
    value = min;
  }

  if (!isNaN(max) && value > max) {
    value = max;
  }

  input.value = value;
}

function getQuantityContainerWrapper(container) {
  if (!container) {
    return null;
  }

  var child = container.firstElementChild;
  while (child) {
    if (child.classList && child.classList.contains('number-input')) {
      return child;
    }
    child = child.nextElementSibling;
  }

  return null;
}

function unwrapQuantityWrapper(wrapper) {
  if (!wrapper || !wrapper.parentNode) {
    return;
  }

  var container = wrapper.parentNode;
  var input = wrapper.querySelector('input[type="number"]');
  var instruction = container.querySelector('.instruction');

  if (input) {
    if (instruction) {
      container.insertBefore(input, instruction);
    } else {
      container.appendChild(input);
    }
  }

  while (wrapper.firstChild) {
    wrapper.removeChild(wrapper.firstChild);
  }
  wrapper.remove();
}

function repairCorruptedEstimateForm(scope) {
  scope.querySelectorAll('.request-fast-estimate .number-input, .page-request-an-estimate .number-input').forEach(function (wrapper) {
    if (wrapper.querySelector('.gform_wrapper, form.gform_wrapper, [id^="gform_wrapper_"]')) {
      var parent = wrapper.parentNode;
      if (!parent) {
        return;
      }

      wrapper.querySelectorAll('input[type="number"]').forEach(function (input) {
        var field = input.closest('.gfield');
        var container = field && field.querySelector('.ginput_container_number');
        if (!container) {
          return;
        }

        var instruction = container.querySelector('.instruction');
        if (instruction) {
          container.insertBefore(input, instruction);
        } else {
          container.appendChild(input);
        }
      });

      while (wrapper.firstChild) {
        parent.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
    }
  });

  scope.querySelectorAll('.request-fast-estimate .increment, .request-fast-estimate .decrement, .page-request-an-estimate .increment, .page-request-an-estimate .decrement').forEach(function (button) {
    if (!button.closest('.ginput_container_number .number-input')) {
      button.remove();
    }
  });

  scope.querySelectorAll('.gform_wrapper[placeholder], [id^="gform_wrapper_"][placeholder]').forEach(function (node) {
    node.removeAttribute('placeholder');
  });
}

function cleanupNonQuantityEstimateSteppers(scope) {
  var estimateRoot = '.request-fast-estimate .gform_wrapper, .page-request-an-estimate .gform_wrapper';
  var plainNumberSelector =
    estimateRoot +
    ' #field_2_8 input[type="number"],' +
    estimateRoot + ' .gfield.size-form-field input[type="number"],' +
    estimateRoot + ' .gfield.size-field input[type="number"]';

  scope.querySelectorAll(plainNumberSelector).forEach(function (input) {
    var container = input.closest('.ginput_container_number');
    var wrapper = getQuantityContainerWrapper(container);
    if (wrapper) {
      unwrapQuantityWrapper(wrapper);
    }
  });
}

function initCustomEstimateFormUI(root) {
  var scope = root || document;
  var estimateRoot = '.request-fast-estimate .gform_wrapper, .page-request-an-estimate .gform_wrapper';

  repairCorruptedEstimateForm(scope);
  cleanupNonQuantityEstimateSteppers(scope);

  ESTIMATE_QUANTITY_FIELD_IDS.forEach(function (fieldId) {
    var field = scope.querySelector('#' + fieldId);
    if (!field) {
      return;
    }

    var container = field.querySelector('.ginput_container_number');
    var input = container && container.querySelector('input[type="number"]');
    if (!container || !input) {
      return;
    }

    var wrapper = getQuantityContainerWrapper(container);
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'number-input';
      var instruction = container.querySelector('.instruction');
      if (instruction) {
        container.insertBefore(wrapper, instruction);
      } else {
        container.appendChild(wrapper);
      }
      wrapper.appendChild(input);
    }

    var instruction = container.querySelector('.instruction');
    if (instruction) {
      instruction.style.display = 'none';
    }

    var up = wrapper.querySelector(':scope > .increment');
    var down = wrapper.querySelector(':scope > .decrement');

    if (!up) {
      up = document.createElement('button');
      up.type = 'button';
      up.className = 'increment';
      up.setAttribute('aria-label', 'Increase value');
      wrapper.appendChild(up);
    }

    if (!down) {
      down = document.createElement('button');
      down.type = 'button';
      down.className = 'decrement';
      down.setAttribute('aria-label', 'Decrease value');
      wrapper.appendChild(down);
    }

    up.innerHTML = '+';
    down.innerHTML = '\u2212';
    reorderEstimateStepper(wrapper, input);
    input.setAttribute('placeholder', '#');
    input.setAttribute('min', '0');

    if (!input.dataset.boundQuantityClamp) {
      input.dataset.boundQuantityClamp = '1';
      input.addEventListener('input', function () {
        clampEstimateQuantityValue(input);
      });
      input.addEventListener('change', function () {
        clampEstimateQuantityValue(input);
      });
    }

    if (!up.dataset.bound) {
      up.dataset.bound = '1';
      up.addEventListener('click', function () {
        var current = parseFloat(input.value, 10);
        var step = parseFloat(input.getAttribute('step'), 10);

        if (isNaN(step) || step <= 0) {
          step = 1;
        }

        if (isNaN(current)) {
          current = 0;
        }

        var min = getEstimateQuantityMin(input);
        var max = parseFloat(input.getAttribute('max'), 10);
        var next = current + step;

        if (next < min) next = min;
        if (!isNaN(max) && next > max) next = max;

        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (!down.dataset.bound) {
      down.dataset.bound = '1';
      down.addEventListener('click', function () {
        var current = parseFloat(input.value, 10);
        var step = parseFloat(input.getAttribute('step'), 10);

        if (isNaN(step) || step <= 0) {
          step = 1;
        }

        if (isNaN(current)) {
          current = 0;
        }

        var min = getEstimateQuantityMin(input);
        var max = parseFloat(input.getAttribute('max'), 10);
        var next = current - step;

        if (next < min) next = min;
        if (!isNaN(max) && next > max) next = max;

        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  scope.querySelectorAll(
    '.request-fast-estimate .frequency-form-field select,' +
    '.page-request-an-estimate .frequency-form-field select'
  ).forEach(function (select) {
    const container = select.closest('.ginput_container_select');
    if (!container) return;

    const selectOption = Array.from(select.options).find(function (opt) {
      return opt.textContent.trim() === 'Select';
    });

    if (selectOption) {
      selectOption.textContent = '';
      if (typeof selectOption.value === 'string' && selectOption.value.toLowerCase() === 'select') {
        selectOption.value = '';
      }
      if (!select.value) {
        select.value = selectOption.value;
      }
    }

    function toggleFrequencyLabel() {
      if (select.value && select.value !== '') {
        container.classList.add('has-value');
      } else {
        container.classList.remove('has-value');
      }
    }

    if (!select.dataset.boundFrequency) {
      select.dataset.boundFrequency = '1';
      select.addEventListener('change', toggleFrequencyLabel);
    }

    toggleFrequencyLabel();
  });
}

function scheduleEstimateFormUI() {
  initCustomEstimateFormUI(document);
  window.requestAnimationFrame(function () {
    initCustomEstimateFormUI(document);
  });
}

// for team members grid: show more/less only when bio exceeds truncated height
function debounceTeamBio(fn, ms) {
  var t;
  return function () {
    clearTimeout(t);
    var ctx = this;
    var args = arguments;
    t = setTimeout(function () {
      fn.apply(ctx, args);
    }, ms);
  };
}

function syncTeamMemberBio(bio) {
  var content = bio.querySelector('.team-members-grid__bio-content');
  var toggle = bio.querySelector('.team-members-grid__bio-toggle');
  if (!content || !toggle) {
    return;
  }

  var labelMore = bio.getAttribute('data-label-more') || 'Show more';
  var labelLess = bio.getAttribute('data-label-less') || 'Show less';
  var textEl = toggle.querySelector('.team-members-grid__bio-toggle-text');

  var wasExpanded = bio.classList.contains('is-expanded');
  bio.classList.remove('is-expanded');
  bio.classList.add('is-truncated');

  var epsilonPx = 2;
  var needsToggle = content.scrollHeight > content.clientHeight + epsilonPx;

  if (!needsToggle) {
    bio.classList.remove('is-truncated', 'is-expanded');
    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (textEl) {
      textEl.textContent = labelMore;
    }
    return;
  }

  toggle.hidden = false;
  if (wasExpanded) {
    bio.classList.add('is-expanded');
    toggle.setAttribute('aria-expanded', 'true');
    if (textEl) {
      textEl.textContent = labelLess;
    }
  } else {
    bio.classList.remove('is-expanded');
    toggle.setAttribute('aria-expanded', 'false');
    if (textEl) {
      textEl.textContent = labelMore;
    }
  }

  if (toggle.dataset.teamBioToggleBound === '1') {
    return;
  }
  toggle.dataset.teamBioToggleBound = '1';
  toggle.addEventListener('click', function () {
    var expanded = bio.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var te = toggle.querySelector('.team-members-grid__bio-toggle-text');
    var lm = bio.getAttribute('data-label-more') || 'Show more';
    var ll = bio.getAttribute('data-label-less') || 'Show less';
    if (te) {
      te.textContent = expanded ? ll : lm;
    }
  });
}

var syncAllTeamMemberBios = function () {
  document.querySelectorAll('[data-team-bio]').forEach(syncTeamMemberBio);
};

var debouncedSyncAllTeamMemberBios = debounceTeamBio(syncAllTeamMemberBios, 150);

function initTeamMemberBioShowMore(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-team-bio]').forEach(syncTeamMemberBio);
}

function bindTeamMemberBioLayoutListeners() {
  if (window.__maidBrigadeTeamBioLayoutBound === '1') {
    return;
  }
  window.__maidBrigadeTeamBioLayoutBound = '1';
  window.addEventListener('resize', debouncedSyncAllTeamMemberBios);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncAllTeamMemberBios);
  }
}

document.addEventListener('DOMContentLoaded', scheduleEstimateFormUI);

document.addEventListener('gform_post_render', scheduleEstimateFormUI);

document.addEventListener('gform_page_loaded', scheduleEstimateFormUI);

if (window.jQuery) {
  window.jQuery(document).on('gform_post_render gform_page_loaded', scheduleEstimateFormUI);
}

// team members
document.addEventListener('DOMContentLoaded', function () {
  initTeamMemberBioShowMore(document);
  bindTeamMemberBioLayoutListeners();
});
